import {Center, Spinner, useApplyTheme} from '@hmlet/ui'

import {RouterProvider} from '@tanstack/react-router'

import {useUser} from '@contexts/UserContext'

import {router} from './main'

export default function AppRouter() {
  const userContext = useUser()
  useApplyTheme()

  // Wait until we know who the user is, otherwise a full page load on /ga4 would be redirected to /login before
  // the session check answers and the deep link would be lost.
  if (userContext.isUserDetailsLoading) {
    return (
      <Center className="h-screen">
        <Spinner size="xl" />
      </Center>
    )
  }
  return <RouterProvider router={router} context={{auth: userContext}} />
}
